module.exports = __webpack_public_path__ + "static/media/icon-upload.a43ceede.svg";